import { Components } from "appworks/components/components";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { SlingoRequestSpinState } from "slingo/states/slingo-request-spin-state";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";

export class FowlRequestSpinState extends SlingoRequestSpinState{
    public onEnter(cascadeSkip?: boolean): void {
        Components.get(MatrixComponent).startSignal.addOnce(()=>Services.get(SoundService).customEvent("base_reel_start"));
        super.onEnter();
    }
}